import { useCatalog } from "../../../hooks";
import { Barometer } from "../../../types";
import { IconButtonBar } from "./icon-button-bar";
import { Pages } from "./pages";

interface Props {
  barometer: Barometer;
  showMobile: boolean;
}

export function Catalog({ barometer, showMobile }: Props) {
  const { currentPage, setPageOnType, scrollPage } = useCatalog();

  return (
    <div>
      <IconButtonBar showMobile={showMobile} onSelect={setPageOnType} currentPage={currentPage} />
      <Pages
        onChangeIndex={scrollPage}
        active={currentPage}
        barometer={barometer}
      />
    </div>
  );
}
